/**
 * Sofortige Reaktionen auf Züge
 */

// Guter Zug
export const GOOD_PLAY = [
  "Sauberer Zug. Respekt... fast.",
  "Ah, smooth! Das fühlt sich gut an.",
  "Nice! Das war ein Move!",
  "Ok, das funktioniert! Mach dein Ding.",
  "Nicht schlecht, nicht schlecht!",
];

// Langweiliger Zug (einzelne Karte, niedrig)
export const BORING_PLAY = [
  "Wow, eine einzelne Karte. Revolutionär.",
  "Langweilig! Aber mach ruhig weiter...",
  "Gähn... ist das alles?",
  "Echt jetzt? Na gut.",
];

// Ungültiger Zug
export const INVALID_PLAY = [
  "Netter Versuch, Cheater. Das geht nicht.",
  "Nee, Alter, geht nicht. Halt dich an die Regeln!",
  "Haha, nice try! Aber so läuft das nicht.",
  "Das ist illegal! Versuch's nochmal.",
];

// Selbst-Sabotage (hohe Karte gespielt obwohl niedrige möglich)
export const SELF_SABOTAGE = [
  "Du spielst die Hohe? Masochist.",
  "Hohe Karte bei niedrigem Einsatz? Mutig. Oder dumm.",
  "Das war teuer. War's das wert?",
];

// Perfektes Timing (exakt getroffen)
export const PERFECT_TIMING = [
  "Exakt getroffen! Das war Absicht, oder?",
  "Genau richtig! Hast du Karten gezählt?",
  "Perfekter Hit! Pure Präzision.",
];

// Letzte Karte gespielt
export const JUST_FINISHED = [
  "Und weg! Keine Karten mehr. Tschüss!",
  "Leer! Alle Karten weg. Geil!",
  "Das war's für dich. Hand leer!",
  "Ja Mann, keine Karten mehr!",
];

// Reset gespielt (höchste 2)
export const RESET_PLAYED = [
  "RESET! Die höchste 2 wischt den Tisch.",
  "Die höchste 2! Alle heul gleich.",
  "Woohoo! Reset. Neue Runde!",
  "Das ist ein Reset, Baby! Alles auf Anfang!",
];

// Bombe gespielt (4+)
export const BOMB_PLAYED = [
  "BOOM! Das war brutal!",
  "Du bist ein Zerstörer! Bomben auf Babies!",
  "Heilige Scheiße, was für ein Zug!",
  "Oha, das sitzt! Vernichtung pur.",
];

// Flush gespielt
export const FLUSH_PLAYED = [
  "Flush! Zeig ihnen, was Farbe bedeutet.",
  "Ein verdammter Flush! Das sitzt.",
  "Farbknaller! Sauber gespielt.",
];

// Straße gespielt
export const STRAIGHT_PLAYED = [
  "Straße! Das ist eine Ansage.",
  "Straight durchgezogen. Respekt!",
  "Eine Straße. Das sitzt!",
];

// Joker triggert
export const JOKER_TRIGGERED = [
  "{jokerName} aktiviert! {effect}",
  "{jokerName} zündet! {effect}",
  "Joker-Power: {jokerName}! {effect}",
];

// Siegel triggert
export const SEAL_TRIGGERED = [
  "{sealName}-Siegel! {effect}",
  "Siegel aktiviert: {sealName}! {effect}",
  "{sealName} zündet! {effect}",
];

// Münzen erhalten
export const COINS_GAINED = [
  "+{amount} Münzen! Kaching!",
  "{amount} Münzen kassiert!",
  "Cha-ching! {amount} Münzen.",
];

// Punkte erhalten
export const POINTS_GAINED = [
  "+{amount} Punkte! Nice.",
  "{amount} Punkte auf die Uhr!",
  "Score: +{amount}!",
];

// Mult erhöht
export const MULT_INCREASED = [
  "Mult auf {mult}x! Juicy.",
  "{mult}x Multiplikator! Es wird saftig.",
  "Multiplikator steigt: {mult}x!",
];

// Schrott losgeworden
export const GOT_RID_OF_JUNK = [
  "Ja, weg mit dem Zwergen-Müll!",
  "Ja, weg mit dem Schrott!",
  "Richtig so, den Mist loswerden!",
];

// Muss mehr spielen
export const PLAY_MORE = [
  "Du musst {count} spielen, Kumpel!",
  "Mehr Karten, bitte! Mindestens {count}!",
  "Eine reicht nicht - spiel {count}!",
];

// Finish him
export const FINISH_HIM = [
  "Ja, Mann, mach's fertig!",
  "Beende es! Gib ihm den Rest!",
  "Finish him! ...oder so.",
];
